import { DISCOVER_LOGIN_METHOD_URL } from '../platform/abp/config'
import { httpJson } from '../platform/abp/httpClient'
import type { DiscoverLoginMethodResult } from '../platform/abp/types'

export async function discoverLoginMethod(email: string): Promise<DiscoverLoginMethodResult> {
  return httpJson<DiscoverLoginMethodResult>(DISCOVER_LOGIN_METHOD_URL, {
    method: 'POST',
    body: { email },
  })
}
